export class TestSubsetStartedEvent {
	constructor(public testID: number, public questionsIDs: number[]) {
	}
}
